const projects = [
  {
    id: "beyond",
    title: "Beyond",
    shortDescription:
      "Application d'exploration spatiale avec données NASA en temps réel, visualisation d'astéroïdes et météo solaire.",
    demoLink: "https://beyond-souz.netlify.app",
    tags: ["React", "Tailwind CSS", "Vite", "Recharts", "API", "NASA"],
    slides: [
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1776935331/beyond-homepage_qw8hj3.webp",
        title: "Page d'accueil",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1776935329/beyond-APOD_eekykd.webp",
        title: "Image du Jour (APOD)",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1776935330/beyond-asteroides_fpklh8.webp",
        title: "Traqueur d'Astéroïdes - Graphique Taille vs Distance",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1776935332/beyond-solaire_sfle7k.webp",
        title: "Météo Spatiale",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1776942414/2026-04-23_13.05.35_beyond-souz.netlify.app_8d6925daad3e_iok5oh.webp",
        title: "APOD - Galerie 7 jours",
      },
    ],
    content: `
      <p>Beyond est une application web d'exploration des données spatiales de la NASA, offrant trois expériences immersives : image astronomique du jour, suivi d'astéroïdes et météo solaire.</p>
        <div>
          <a href="https://beyond-souz.netlify.app" class="download-file" target="_blank" rel="noopener noreferrer">
            Démo Live
          </a>
        </div>
        </br>
      <span>Fonctionnalités Principales</span>
      <ul class="list">
        <li>Image du jour (APOD) avec navigation par date, mode aléatoire et galerie des 7 derniers jours</li>
        <li>Traqueur d'astéroïdes avec tableau triable, badges de dangerosité et compteurs en temps réel</li>
        <li>Graphique interactif taille vs distance des astéroïdes proches de la Terre</li>
        <li>Météo spatiale : éruptions solaires, tempêtes géomagnétiques et éjections de masse coronale</li>
        <li>Système de retry automatique et cache mémoire pour gérer les limites de l'API</li>
        <li>Design éditorial avec starfield animé, typographie custom et animations fade-in</li>
      </ul>
      <span>Technologies Utilisées</span>
      <ul class="list">
        <li>Framework <span class="bolder">React 19</span> avec routing via <span class="italic-semiBold">React Router v7</span></li>
        <li>Styling utilitaire avec <span class="bolder">Tailwind CSS v4</span> et design responsive</li>
        <li>Visualisation de données avec <span class="italic-semiBold">Recharts</span> (scatter plots, bar charts)</li>
        <li>Intégration de trois API <span class="italic-semiBold">NASA</span> : APOD, NeoWs et DONKI</li>
        <li>Bundler <span class="bolder">Vite</span> pour un développement rapide</li>
      </ul>
        </br>
      <p>L'application implémente un système de cache en mémoire avec TTL, un mécanisme de retry avec backoff progressif pour les erreurs serveur, et une architecture modulaire en composants réutilisables.</p>
    `,
    techs: [
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1701692589/react_ftj6ol.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881731/tailwind_yw3i1g.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1776934867/Vite_xdg03f.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881733/api_ue2yxg.svg",
      "https://upload.wikimedia.org/wikipedia/commons/e/e5/NASA_logo.svg",
    ],
  },

  {
    id: "provision",
    title: "ProVision",
    shortDescription:
      "Plateforme VOD avec affichage dynamique, authentification et intégration API TMDB.",
    demoLink: "http://provision.kesug.com/",
    tags: ["PHP", "MySQL", "JavaScript", "HTML", "CSS", "API", "TMDB"],
    slides: [
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1738926058/index_one_jigouj.webp",
        title: "Page d'accueil",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1738926058/index_two_ahhwzd.webp",
        title: "Page d'accueil - Part two",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1738926058/moviesNews_km60gj.webp",
        title: "Page des films - Nouveautés",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1738926058/searchResults_ziie5i.webp",
        title: "Résultat recherche",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1738926058/moviesDetails_mjafrv.webp",
        title: "Détails d'un film",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1738926058/register_v50ktv.webp",
        title: "Créer un compte",
      },
    ],
    content: `
      <p>ProVision est une plateforme de vidéo à la demande (VOD) permettant aux utilisateurs de consulter un large choix de films et de séries.</p>
        <div>
          <a href="http://provision.kesug.com/" class="download-file" target="_blank" rel="noopener noreferrer">
            Démo Live
          </a>
        </div>
        </br>
      <span>Fonctionnalités Principales</span>
      <ul class="list">
        <li>Affichage dynamique des films et séries par genres, tendances et nouveautés</li>
        <li>Détails complets des films et séries : synopsis, casting, saisons et épisodes</li>
        <li>Système d'authentification avec inscription, connexion et déconnexion</li>
        <li>Recherche avancée pour trouver rapidement un contenu</li>
        <li>Gestion des abonnements avec différents plans disponibles</li>
        <li>Interface responsive adaptée aux mobiles et tablettes</li>
      </ul>
      <span>Technologies Utilisées</span>
      <ul class="list">
        <li>Backend en <span class="bolder">PHP</span> avec architecture orientée objet</li>
        <li>Base de données <span class="bolder">MySQL</span> pour la gestion des utilisateurs</li>
        <li>Intégration de l'API <span class="italic-semiBold">TMDB</span> pour les données des films et séries</li>
        <li>Frontend avec <span class="bolder">HTML/CSS</span> et <span class="bolder">JavaScript</span></li>
        <li>Design responsive avec <span class="italic-semiBold">Swiper.js</span> pour les carrousels</li>
      </ul>
      <div>
          <a href="https://github.com/souleimane-z/ProVision" class="download-file" target="_blank" rel="noopener noreferrer">
            Lien Github
          </a>
      </div>
        </br>
      <p>L'application met en œuvre des concepts avancés comme le cache des requêtes API, la gestion sécurisée des sessions utilisateurs, et une architecture modulaire pour une maintenance facilitée.</p>
    `,
    githubLink: "https://github.com/souleimane-z/ProVision",
    techs: [
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1726757329/php_ysd7hl.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881734/mysql_r0tqsj.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881731/javascript_sdrddu.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881736/html5_gvbsau.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881735/css3_k38wzt.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1738926622/blue_square_1-5bdc75aaebeb75dc7ae79426ddd9be3b2be1e342510f8202baf6bffa71d7f5c4_ymuawu.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881733/api_ue2yxg.svg",
    ],
  },
  {
    id: "sakura-blend",
    title: "Sakura Blend",
    shortDescription:
      "Site web de restaurant japonais avec gestion admin, réservations et formulaires.",
    demoLink: "http://souleimane-z.wuaze.com/index.php?i=1",
    tags: ["PHP", "JavaScript", "HTML", "CSS"],
    slides: [
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1735056675/homePage_dkjqbl.png",
        title: "Home page",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1735056675/homePage2_aonh6j.png",
        title: "Home page suite",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1735056674/homePage3_xa2xxl.png",
        title: "Home page + footer",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1735056674/menu_u6bi93.png",
        title: "menu : les entrées",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1735056672/Contact-form_confirmation_nauztb.png",
        title: "form contact + confirmation",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1735056672/reservation-form_gqqojv.png",
        title: "Formulaire de réservation",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1735056671/admin-login_r3jy6x.png",
        title: "Connexion admin",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1735056672/adminSession-NewReservation_v7jqac.png",
        title: "Nouvelles réservation",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1735056673/adminSession-OldReservation_vqnln6.png",
        title: "Réservation archivées",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1735056671/adminSession-NewMessages_ae960f.png",
        title: "Nouveaux messages",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1735056673/adminSession-OldMessages_wb83ns.png",
        title: "Messages archivées",
      },
    ],
    content: `
      <div>
          <a href="https://github.com/souleimane-z/sakura-blend" class="download-file" target="_blank" rel="noopener noreferrer">
              Code source sur GitHub
          </a>
      </div>
      <div>
          <a href="http://souleimane-z.wuaze.com/index.php?i=1" class="download-file" target="_blank" rel="noopener noreferrer">
              Démo
          </a>
      </div>
      <br>
      <br>
      <h3>Fonctionnalités principales :</h3>
        <ul>
            <li>Langages:  <span class="bolder">PHP</span>, <span class="bolder">JavaScript</span> et <span class="bolder">HTML/CSS</span></li>
            <li>Animations loader</li>
            <li>Menu : affichage dynamique</li>
            <li>Formulaire de contact</li>
            <li>Formulaire pour réserver une table</li>
            <li>Envoi des formulaires dans un fichier CSV</li>
            <li>Interface administrateur pour afficher et archiver les réservations et messages</li>
         </ul>
      <br>
      <br>
      
        <p>
          Site web codé en <span class="bolder">PHP</span>, <span class="bolder">JavaScript</span> et <span class="bolder">HTML/CSS</span> d'un restaurant Japonais Traditionnel.
          <br>Dans la page d'accueil, nous retrouvons la présentation du restaurant avec ses plats phares ainsi qu'un carrousel de témoignages.
          <br>Grâce à la barre de navigation, on peut se diriger vers la page de la carte avec un affichage dynamique du menu et ses différentes sections (entrées, plats, desserts...). Les données des formulaires de contact et de réservation sont envoyées vers des fichiers CSV. Ces données sont ensuite récupérées grâce à PHP pour être affichées dans la session administrateur. Celui-ci aura la possibilité de vérifier les nouvelles réservations et d'accéder aux informations de contact. L'administrateur/administratrice pourra aussi archiver les messages et réservations pour une vue plus claire.
          <br>Pour accéder à la partie administrateur, il faut cliquer sur l'icône de cadenas située tout en bas de la page. Vous serez redirigé vers un formulaire de connexion (identifiants disponibles dans includes/admin-config). Une fois connecté, vous aurez accès aux fonctionnalités.
        </p>
    `,
    githubLink: "https://github.com/souleimane-z/sakura-blend",
    techs: [
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1726757329/php_ysd7hl.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881731/javascript_sdrddu.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881736/html5_gvbsau.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1735058142/aa031572455185b8e9ad7c1bc79f3816a1eb2a1b_j3yaxh.png",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1735058171/OIP_gtylhu.jpg",
    ],
  },
  {
    id: "les-clefs-de-la-ville",
    title: "Les Clefs de la Ville",
    shortDescription:
      "Système de réservation de billets avec génération de QR code et PDF.",
    tags: ["PHP", "Composer", "PDF", "QR Code"],
    slides: [
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1726757174/home_head_oiulgp.webp",
        title: "Home page",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1726757174/home_form_rezdek.webp",
        title: "Reservation form",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1726757174/confirmation_qsxy3n.webp",
        title: "Reservation confirmation",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1726757174/pdf_ywse9e.webp",
        title: "Generated PDF ticket",
      },
    ],
    content: `
      <p>Ticket Reservation est un projet qui permet aux utilisateurs de réserver des places pour un événement à l'aide d'un formulaire simple, générer un pass avec un code QR et un PDF du billet.</p>
      <h3>Caractéristiques principales :</h3>
      <ul>
          <li>Formulaire de réservation avec validation</li>
          <li>Génération de QR code basé sur les informations de réservation</li>
          <li>Création dynamique d'un fichier PDF du billet</li>
          <li>Utilisation de <span class="bolder">PHP</span> avec <span class="bolder">Composer</span> pour gérer les dépendances</li>
      </ul>
      <div>
          <a href="https://github.com/souleimane-z/tecket-reservation" class="download-file" target="_blank" rel="noopener noreferrer">
              Code source sur GitHub
          </a>
      </div>
    `,
    githubLink: "https://github.com/souleimane-z/tecket-reservation",
    techs: [
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1726757329/php_ysd7hl.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1726757385/composer_e1ggu0.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1726757271/xampp_x4etoh.svg",
    ],
  },
  {
    id: "noteit",
    title: "Note-it",
    shortDescription:
      "Application de prise de notes style Google Keep en React TypeScript.",
    demoLink: "https://note-it-sz.netlify.app",
    tags: ["React", "TypeScript", "JavaScript", "CSS", "LocalStorage"],
    slides: [
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1720697587/noteit_light_k2wpls.webp",
        title: "main page, mode jour",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1720697587/noteit_dark_qtga9f.webp",
        title: "main page, mode nuit",
      },
    ],
    content: `
      <p>Application de prise de note légère dans le style de Google Keep</p>
        <div>
          <a href="https://note-it-sz.netlify.app" class="download-file " target="_blank" rel="noopener noreferrer">
        Démo 
          </a>
        </div>
        </br>
      <span>Fonctionnalités Principales</span>
      <ul class="list">
        <li>Recherche des notes.</li>
        <li>Création, modification et suppression de notes.</li>
        <li>Archivage des notes.</li>
        
      </ul>
      <span>Technologies Utilisées</span>
      <ul class="list">
        <li><span class="bolder">Typescript</span> via le framework <span class="bolder">ReactJS </span></li>
        <li><span class="bolder">CSS</span></li>
        <li><span class="bolder">localstorage</span> pour conserver les données.</li>
        <li>Déployé sur <span class="bolder">netlify</span>.</li>
      </ul><div>
          <a href="https://github.com/souleimane-z/taskmanager" class="download-file " target="_blank" rel="noopener noreferrer">
Code source 
          </a>
        </div>
    `,
    githubLink: "https://github.com/souleimane-z/taskmanager",
    techs: [
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881731/typescript_ki78sv.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881731/react_ltwhrj.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881731/javascript_sdrddu.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881735/css3_k38wzt.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718958810/netlify_aelfck.svg",
    ],
  },
  {
    id: "prepquest",
    title: "Prep-Quest",
    shortDescription:
      "Application fullstack de préparation aux entretiens avec authentification JWT et API REST.",
    tags: ["JavaScript", "Node.js", "Express", "MongoDB", "JWT", "API"],
    slides: [
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1719236945/MAIN_elwyfh.webp",
        title: "Page principale",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1719236954/Signup-ipadPro_ik59eq.webp",
        title: "Page d'inscription sur iPad Pro",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1719236950/Login-ipadPro_pvmcwm.webp",
        title: "Page de connexion sur iPad Pro",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1719236946/main2-iphone_uylroo.webp",
        title: "Vue principale sur iPhone",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1719236945/main1-iphone_za1pfa.webp",
        title: "Vue secondaire sur iPhone",
      },
    ],
    content: `
    <p>Prep-Quest est une application web conçue pour aider les utilisateurs à préparer efficacement leurs entretiens d'embauche. Développée avec <span class="bolder">JavaScript</span>, <span class="bolder">Node.js</span>, et <span class="bolder">MongoDB</span>, cette application offre une plateforme interactive pour gérer et organiser des questions d'entretien.</p>
    
    <h3>Caractéristiques principales :</h3>
    <ul>
        <li>Interface utilisateur intuitive et responsive, adaptée à différents appareils</li>
        <li>Système d'authentification sécurisé avec <span class="bolder">JWT</span> (JSON Web Tokens)</li>
        <li>Création et gestion de catégories de questions personnalisées</li>
        <li>Ajout, modification et suppression de questions d'entretien</li>
        <li>Fonctionnalité de marquage des questions comme complétées</li>
        <li>Backend robuste utilisant <span class="bolder">Node.js</span> et <span class="bolder">Express.js</span></li>
        <li>Base de données <span class="bolder">MongoDB</span> pour un stockage efficace des données</li>
        <li><span class="bolder">API RESTful</span> pour une communication fluide entre le frontend et le backend</li>
    </ul>
    
    <p>Cette application démontre une mise en œuvre complète d'une app <span class="italic-semiBold">Fullstack</span>, offrant une expérience utilisateur fluide et une architecture backend solide. Elle illustre également l'utilisation de bonnes pratiques en matière de sécurité web et de gestion des données utilisateur.</p>

    `,
    githubLink: "https://github.com/souleimane-z/PrepQuest",
    techs: [
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881731/javascript_sdrddu.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881734/mongodb_x5llwm.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881735/nodeJS_mgeyrh.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881736/html5_gvbsau.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881735/css3_k38wzt.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881733/api_ue2yxg.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1719237312/jwtio-json-web-token_mope1u.svg",
    ],
  },
  {
    id: "shopping-list-modern",
    title: "Shopping List v2",
    shortDescription:
      "Application de gestion de courses avec export PDF et thème clair/sombre.",
    demoLink: "https://shopping-list-modern.netlify.app",
    tags: ["JavaScript", "HTML", "CSS", "LocalStorage", "PDF"],
    slides: [
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1767796214/home-dark-theme_wdklk6.png",
        title: "Homepage – Dark mode",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1767796214/full-with-articles_kz7crd.png",
        title: "Liste complète des articles",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1767796214/modify-article_sgs3hg.png",
        title: "Modification d’un article",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1767797878/Capture_juzkcm.png",
        title: "PDF généré",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1767796214/home-light-theme_q5vixw.png",
        title: "Homepage – Light mode",
      },
    ],
    content: `
    <p>
      <strong>Shopping List</strong> est une application web moderne permettant de créer,
      organiser et comparer des produits avant achat.
      Elle met l’accent sur l’<span class="bolder">expérience utilisateur</span>,
      la lisibilité et la performance.
    </p>

    <div>
      <a href="https://shopping-list-modern.netlify.app"
         class="download-file"
         target="_blank"
         rel="noopener noreferrer">
        Démo Live
      </a>
    </div>

    <br />

    <span>Fonctionnalités principales</span>
    <ul class="list">
      <li>Ajout, modification et suppression de produits</li>
      <li>Affichage sous forme de cartes avec images uniformisées</li>
      <li>Recherche et tri de la liste (&#8593; &#8595; : prix, date, nom)</li>
      <li>Export de la liste au format <span class="bolder">PDF</span></li>
      <li>Mode clair / sombre</li>
      <li>Sauvegarde des données via <span class="bolder">LocalStorage</span></li>
    </ul>

    <span>Technologies utilisées</span>
    <ul class="list">
      <li><span class="bolder">HTML5</span>, <span class="bolder">CSS3</span>, <span class="bolder">JavaScript</span></li>
      <li>Design UI moderne (glassmorphism, cartes, animations légères)</li>
      <li>Accessibilité (focus, contrastes, ARIA)</li>
      <li>Déploiement sur <span class="bolder">Netlify</span></li>
    </ul>

    <p>
      Ce projet illustre ma capacité à concevoir une interface moderne,
      à structurer une application front-end proprement
      et à porter une attention particulière aux détails UX/UI ainsi qu'a l'accessibilité tout en suivant les bonne pratiques de référencement SEO.
    </p>
  `,
    techs: [
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881731/javascript_sdrddu.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1767796826/jsPDF_zpfemx.webp",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881736/html5_gvbsau.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881735/css3_k38wzt.svg",
    ],
  },
  {
    id: "passwordgen",
    title: "PasswordGen.py",
    shortDescription:
      "Générateur de mots de passe sécurisés avec Python Flask.",
    demoLink: "http://souzzfr.pythonanywhere.com/",
    tags: ["Python", "Flask", "HTML", "CSS", "JavaScript"],
    slides: [
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1719066048/CQP8cFo_puipwm.webp",
        title: "main page, passwordgen",
      },
    ],
    content: `
    <p>Ce projet est une application web élégante et fonctionnelle qui génère des mots de passe aléatoires et sécurisés. Développée avec <span class="bolder">Python</span> et <span class="bolder">Flask </span> pour le backend, et <span class="bolder">HTML/CSS</span> pour le frontend.</p>
    
    <h3>Caractéristiques principales :</h3>
    <ul>
        <li>Interface utilisateur intuitive et responsive</li>
        <li>Génération de mots de passe personnalisables en longueur</li>
        <li>Utilisation de caractères alphanumériques et spéciaux pour une sécurité accrue</li>
        <li>Backend robuste utilisant <span class="bolder">Python</span> et <span class="bolder">Flask </span></li>
        <li>Frontend élégant avec un design moderne en <span class="bolder">HTML</span> et <span class="bolder">CSS </span></li>
        <li>Site mis en ligne sur <span class="italic-semiBold">pythonanywhere</span></li>
    </ul>
    
    <div>
        <a href="http://souzzfr.pythonanywhere.com/" class="download-file " target="_blank" rel="noopener noreferrer">Voir une démo</a>
        <a href="https://github.com/souleimane-z/passwordgen.py" class="download-file " target="_blank" rel="noopener noreferrer">Code source</a>
    </div>
    `,
    githubLink: "https://github.com/souleimane-z/passwordgen.py",
    techs: [
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1719065285/flask_alpgzv.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881736/python_aonlz6.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881731/javascript_sdrddu.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881736/html5_gvbsau.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881735/css3_k38wzt.svg",
    ],
  },
  {
    id: "weathertoday",
    title: "Weather Today",
    shortDescription:
      "Application météo en temps réel avec API proxy pour protéger les clés.",
    demoLink: "https://souleimane-z.github.io/weather-today/",
    tags: ["React", "JavaScript", "Node.js", "Express", "API"],
    slides: [
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1718365650/weather-today_hwyb1v.webp",
        title: "main page, weather shown",
      },
    ],
    content: `
      <p>Application de météo en temps réel.</p>
        <div>
          <a href="https://souleimane-z.github.io/weather-today/" class="download-file " target="_blank" rel="noopener noreferrer">
Démo GitPages
          </a>
        </div>
        </br>
      <span>Fonctionnalités Principales</span>
      <ul class="list">
        <li>Recherche par Ville : Entrez le nom d'une ville pour obtenir instantanément les conditions météorologiques actuelles.</li>
        <li>Détails Météorologiques : Affichage des informations essentielles telles que la température, les conditions météorologiques, l'humidité et la vitesse du vent.</li>
        <li>Design Responsive : Adapté à tous les types d'écrans, des ordinateurs de bureau aux smartphones.</li>
      </ul>
      <span>Technologies Utilisées</span>
      <ul class="list">
        <li><span class="bolder">ReactJS </span></li>
        <li><span class="bolder">Axios, Express.js et Node.js </span></li>
        <li><span class="bolder">Vercel </span>: Pour heberger le backend.</li>
        <li>Déployé sur <span class="bolder">GitHub Pages </span>.</li>
      </ul>
      <p>Pour protéger la clé API utilisée pour accéder aux données météorologiques, une <span class="italic-semiBold">API Proxy</span> a été créée. C'est une API REST, et une API Proxy a été mise en place. Cette API Proxy interagit avec l'<span class="italic-semiBold">API OpenWeatherMap</span> pour l'extraction des données. C'est une API OpenWeatherMap, garantissant que la <span class="italic-semiBold">clé API</span> n'est jamais exposée dans le code front-end public.</p>

    `,
    githubLink: "https://github.com/souleimane-z/weather-today",
    techs: [
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881731/react_ltwhrj.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718958811/vercel_kegfnm.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881731/javascript_sdrddu.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881735/nodeJS_mgeyrh.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881736/express_s7lr4n.svg",
    ],
  },
  {
    id: "songinsight",
    title: "SongInsight Python",
    shortDescription:
      "Application desktop Python pour extraire les métadonnées de fichiers audio.",
    tags: ["Python", "Tkinter", "Desktop App"],
    slides: [
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1718196170/songinsight_mainframe_wc89wr.png",
        title: "main program",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1718196168/songinsight_exportFile_aq7fib.png",
        title: "Export File",
      },
    ],
    content: `
        <p>SongInsight est une application <span class="bolder">Python</span> entièrement
        fonctionnelle pour extraire et afficher les métadonnées des fichiers audio.</p>
        <ul class="list">
          <li>Prend en charge plusieurs formats audio : MP3, FLAC, ALAC, M4A, MP4, OGG, WAV et WV.</li>
          <li>Affiche toutes les métadonnées disponibles dans un tableau trié avec les clés des métadonnées en gras.</li>
          <li>Affiche la durée du fichier audio en heures, minutes et secondes (h:min:s).</li>
          <li>Permet d'exporter les métadonnées dans un fichier texte nommé d'après le fichier audio.</li>
        </ul>
        <p>Développé en utilisant <span class="bolder">Python</span> avec la bibliothèque <span class="italic-semiBold">mutagen</span> pour l'extraction des métadonnées, et <span class="italic-semiBold">Tkinter</span> pour l'interface graphique.</p>
      `,
    githubLink: "https://github.com/souleimane-z/SongInsight",
    techs: [
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881736/python_aonlz6.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718981845/mutagen_dic1c1.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718982307/tkinter_qqtnd9.png",
    ],
  },
  {
    id: "Shopping_List",
    title: "Shopping List",
    shortDescription:
      "Application de liste d'achat avec export PDF et LocalStorage.",
    demoLink: "https://shopping-list-alpha-three.vercel.app/",
    tags: ["HTML", "CSS", "JavaScript", "LocalStorage", "PDF"],
    slides: [
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1723916821/og-image-gigapixel_oh3bsd.png",
        title: "Homepage",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1723916824/DNdPYTm_qdbnfb.png",
        title: "List",
      },
    ],
    content: `
      <p>Application de liste d'achat.</p>
        <div>
          <a href="https://shopping-list-alpha-three.vercel.app/" class="download-file " target="_blank" rel="noopener noreferrer">
Démo
          </a>
        </div>
        </br>
      <span>Fonctionnalités Principales</span>
      <ul class="list">
        <li>Ajout d'un produit à la liste. Avec son nom, image, prix et URL vers le site marchand.</li>
        <li>Possibilité d'exporter la liste sous format PDF.</li>
        <li>Enregistrement de la liste dans le navigateur grâce au LocalStorage.</li>
    `,
    // githubLink: "https://github.com/souleimane-z/shopping_list",
    techs: [
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881736/html5_gvbsau.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881735/css3_k38wzt.svg",
    ],
  },
  {
    id: "portfolio",
    title: "Portfolio",
    shortDescription:
      "Ce portfolio — conçu en React avec EmailJS et déployé sur Netlify.",
    tags: ["React", "JavaScript", "Node.js", "API", "Netlify"],
    slides: [
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700124774/header_dkarni.png",
        title: "header",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700124776/AboutMe_eng9cf.png",
        title: "aboutMe",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700124778/projects_qzvmdk.png",
        title: "projects",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1718282775/contactMe1-gigapixel-standard_v2-2x_ul6tci.webp",
        title: "Send a mail from portfolio",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1718282768/contactMe3-gigapixel-standard_v2-2x_uaac5f.webp",
        title: "email received",
      },
    ],
    content: `
        <p>Ce site est principalement codé en <span class="bolder">JavaScript</span> grâce à l'utilisation de <span class="bolder">ReactJS</span> comme Framework, et ses Hooks tels que <span class="italic-semiBold">useState</span> & <span class="italic-semiBold">useEffect</span>. <span class="bolder">NodeJS</span> sert, ici, à envoyer les messages du formulaire de contact directement vers mon Gmail grâce à <span class="italic-semiBold">Nodemailer</span>.</p>
        <p>Le site est déployé sur Netifly, et j'utilise <a href="https://uptimerobot.com/" class="link-paragraph" target="_blank" rel="noopener noreferrer">Uptime Robot</a> pour monitorer l'application et empêcher qu'elle se mette en veille au bout de 30min pour un temps de chargement plus court.</p>
        <p>Le but de ce Portfolio était de créer un site "one-page" dans lequel on pouvait retrouver toutes mes informations essentielles sans qu'il ne soit trop lourd à la lecture.<br>Les images sont hébergées sur <span class="italic-semiBold">Cloudinary</span> pour encore une fois limiter le poids du site. Vous avez la possibilité de télécharger mon CV présenté de façon plus formelle. Dans lequel vous retrouverez d'autres manières de me contacter comme mon numéro de téléphone.</p>
      `,
    githubLink: "https://github.com/souleimane-z/Portfolio_React2022",
    techs: [
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881731/react_ltwhrj.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881735/nodeJS_mgeyrh.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881731/javascript_sdrddu.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718958810/netlify_aelfck.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881733/api_ue2yxg.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881731/cloudflare_lrzi5i.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881732/cloudinary_vepdwg.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881733/uptimerobot_n434ik.svg",
    ],
  },
  {
    id: "portfolio-v2",
    title: "Portfolio v2",
    shortDescription:
      "Portfolio redesigné en React — dark/light theme, design minimaliste pro et responsive.",
    demoLink: "https://www.souleimane-z.com/",
    tags: ["React", "JavaScript", "CSS3", "Netlify", "Cloudinary"],
    slides: [
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1774259844/1souleimane-z__homepage_wbketv.webp",
        title: "Page d'accueil – Dark theme",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1774259843/2souleimane-z___projects-selected_wnwrns.webp",
        title: "Projets – Sélection mise en avant",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1774259843/3souleimane-z_-_projects-modal-open_ftswfd.webp",
        title: "Modal projet ouverte",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1774259844/4souleimane-z___projects-fullList_hwzarm.webp",
        title: "Liste complète des projets",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1774259843/5souleimane-z___abouteMe-Cursus_g1y74w.webp",
        title: "À propos – Cursus & Parcours",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1774259844/6souleimane-z___contactForm_bwtc2y.webp",
        title: "Formulaire de contact",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1774259843/7souleimane-z___responsive-mockups_osbenj.webp",
        title: "Responsive – Mockups mobile & tablette",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1774259843/8souleimane-z_-_homepage-light-theme_nt3cbk.webp",
        title: "Page d'accueil – Light theme",
      },
    ],
    content: `
      <p>Refonte complète de mon portfolio personnel avec un <span class="bolder">design minimaliste et professionnel</span>, pensé pour mettre en valeur mes projets et compétences de manière claire et élégante.</p>

      <div>
        <a href="https://www.souleimane-z.com/" class="download-file" target="_blank" rel="noopener noreferrer">
          Voir le site
        </a>
      </div>

      <br />

      <span>Points forts du redesign</span>
      <ul class="list">
        <li>Thème <span class="bolder">Dark / Light</span> avec toggle et sauvegarde via <span class="italic-semiBold">localStorage</span></li>
        <li>Layout moderne et épuré avec sections bien délimitées</li>
        <li>Système de projets avec <span class="bolder">sélection featured</span>, filtres par tags et <span class="bolder">modal détaillée</span> avec slider d'images</li>
        <li>Section À propos avec onglets <span class="italic-semiBold">Profil</span>, <span class="italic-semiBold">Cursus</span>, <span class="italic-semiBold">Compétences</span> et <span class="italic-semiBold">Centres d'intérêt</span></li>
        <li>Formulaire de contact intégré avec <span class="bolder">EmailJS</span></li>
        <li>Téléchargement du CV en un clic</li>
        <li>Design <span class="bolder">100% responsive</span> (mobile, tablette, desktop)</li>
      </ul>

      <span>Technologies & Stack</span>
      <ul class="list">
        <li><span class="bolder">React</span> avec hooks : <span class="italic-semiBold">useState</span>, <span class="italic-semiBold">useEffect</span>, <span class="italic-semiBold">useMemo</span>, <span class="italic-semiBold">useCallback</span>, <span class="italic-semiBold">useRef</span></li>
        <li>Custom hook <span class="italic-semiBold">useTheme</span> pour la gestion du thème clair/sombre</li>
        <li><span class="bolder">CSS3</span> avec variables CSS pour le theming dynamique</li>
        <li>Images optimisées au format <span class="bolder">WebP</span> hébergées sur <span class="italic-semiBold">Cloudinary</span></li>
        <li>Déploiement continu sur <span class="bolder">Netlify</span></li>
      </ul>

      <p>Ce projet reflète mon approche du développement front-end : un code propre et modulaire, une attention particulière à l'<span class="bolder">expérience utilisateur</span> et aux <span class="bolder">performances</span>, avec un design qui reste sobre et professionnel.</p>
    `,
    techs: [
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881731/react_ltwhrj.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881731/javascript_sdrddu.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881735/css3_k38wzt.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718958810/netlify_aelfck.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881732/cloudinary_vepdwg.svg",
    ],
  },
  {
    id: "groupomania",
    title: "Groupomania",
    shortDescription:
      "Réseau social d'entreprise fullstack avec React, Node.js, Express et MySQL.",
    tags: ["React", "JavaScript", "Node.js", "Express", "MySQL", "Tailwind"],
    slides: [
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700124977/homepage_o213fi.png",
        title: "homepage",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700124976/phone_pbidvt.jpg",
        title: "phone",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700124976/tablet_zzuqex.jpg",
        title: "tablet",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700124976/connexion_vly7of.png",
        title: "connexion",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700124976/signup_z7gyp6.png",
        title: "inscription",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700124977/post_ufsc35.png",
        title: "post",
      },
    ],
    content: `
        <p>Simulation d'un réseau social d'entreprise totalement fonctionnel.</p>
        <ul class="list">
          <li>On a la possibilité de créer un compte grâce à une adresse mail et un username qui sera unique. Les mots de passe sont hashé.</li>
          <li>Un compte administrateur qui pourra supprimer toutes les publications et commentaires qu'il-elle souhaite.</li>
          <li>Partager du contenu multimédia, et texte.</li>
          <li>Interagir en commentant les publications.</li>
        </ul>
        <p>Codé grâce au Framework <span class="bolder">ReactJS</span> et <span class="bolder">Tailwind CSS</span> pour le style, pour la partie backend une base de données <span class="bolder">MySQL</span> a été implémenté et intégré grâce à <span class="italic-semiBold">NodeJS</span> et <span class="italic-semiBold">Express</span>.</p>
      `,
    githubLink: "https://github.com/souleimane-z/SZ_P7_01032022",
    techs: [
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881731/tailwind_yw3i1g.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881731/react_ltwhrj.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881734/mysql_r0tqsj.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881735/nodeJS_mgeyrh.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881736/express_s7lr4n.svg",
    ],
  },
  {
    id: "hot-Takes",
    title: "Hot-Takes",
    shortDescription:
      "API sécurisée pour une application d'avis gastronomiques avec Node.js et MongoDB.",
    tags: ["Node.js", "MongoDB", "API"],
    slides: [
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700124989/Login_xrjzp5.jpg",
        title: "Login",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700124990/homepage_ttupxp.jpg",
        title: "Homepage",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700124990/sauce_zgar5c.jpg",
        title: "Sauce",
      },
    ],
    content: `
        <p>Construire une API sécurisée pour une application d'avis gastronomiques.<br>Scénario : la marque Piiquante souhaite créer un site dans lequel les utilisateurs peuvent noter leurs sauces piquantes favorites en les ajoutant eux-mêmes.<br>Je devais travailler sur le backend, et intégrer l'API. Les utilisateurs pouvaient ensuite ajouter une sauce avec une description et une photo puis les autres utilisateurs pourront ajouter un "like" ou un "dislike" à celle-ci.</p>
        <p>Le travail a été effectué depuis <span class="bolder">MongoDB</span> et <span class="bolder">NodeJS</span>. Pour la sécurité et l'authentification, j'ai utilisé <span class="italic-semiBold">Mongoose-unique-validator</span>, <span class="italic-semiBold">email-validator</span>, ou encore <span class="italic-semiBold">password-validator</span>.</p>
      `,
    githubLink: "https://github.com/souleimane-z/ZeggaiSouleimane_6_140122",
    techs: [
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881735/nodeJS_mgeyrh.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881733/api_ue2yxg.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881734/mongodb_x5llwm.svg",
    ],
  },
  {
    id: "kanap",
    title: "Kanap",
    shortDescription:
      "Site e-commerce de sofas avec panier, commande et intégration API.",
    tags: ["JavaScript", "Node.js", "API"],
    slides: [
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700125031/home_imkiy8.jpg",
        title: "Home",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700125029/product_c9ejye.jpg",
        title: "Product",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700125030/recap_mc7zis.jpg",
        title: "Recap",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700125030/infos-commande_pppiab.jpg",
        title: "infos commande",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700125031/validation-commande_jqflh3.jpg",
        title: "Validation commande",
      },
    ],
    content: `
        <p>Site de vente de sofas en ligne. Comprenant:</p>
        <ul>
          <li>Une page d'accueil avec tous les canapés.</li>
          <li>Quand on clique sur un produit : on est redirigé vers une page détaillée avec la description de celui-ci.</li>
          <li>Choix de la couleur, et la quantité pour ajouter au panier.</li>
          <li>Page Panier avec : un récapitulatif des canapés ajoutés au panier.</li>
          <li>Formulaire à remplir pour commander</li>
          <li>Une fois le formulaire correctement rempli : redirection vers une page où l'on retrouve le numéro de commande</li>
        </ul>
        <p>Je devais travailler sur le backend. Avec <span class="bolder">Node JS</span>, mon rôle était d'unifier les travaux déjà réalisés par l’équipe en intégrant dynamiquement les éléments de l’API dans les différentes pages web avec <span class="bolder">JavaScript</span> et créer un <span class="italic-semiBold">plan de test d’acceptation</span>.</p>
        <div>
          <a href="https://app.box.com/s/5yfv1nwrbxmrxomuyqils4ek1h2hxqgj" target="_blank" rel="noopener noreferrer" class="download-file">
Plan de test d’acceptation
          </a>
        </div>
      `,
    githubLink: "https://github.com/souleimane-z/ZeggaiSouleimane_5_11112021",
    techs: [
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881735/nodeJS_mgeyrh.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881731/javascript_sdrddu.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718983533/excel-svgrepo-com_nkli94.svg",
    ],
  },
  {
    id: "la-Chouette-Agence",
    title: "La chouette agence",
    shortDescription:
      "Audit et optimisation SEO/accessibilité d'un site de webdesign.",
    demoLink: "https://souleimane-z.github.io/zeggaisouleimane_4_20102021/",
    tags: ["SEO", "Accessibilité", "Audit"],
    slides: [
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700125048/un_fxjuoy.jpg",
        title: "un",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700125049/deux_qbg0v0.jpg",
        title: "deux",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700125048/trois_ucnfo7.jpg",
        title: "trois",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700125046/quatre_vsgmhe.jpg",
        title: "quatre",
      },
    ],
    content: `
        <p><i>La Chouette Agence</i> est une agence de webdesign qui aimerait augmenter son trafic et l'accessibilité de son site. Pour ce faire, je devais trouver tous les axes d'amélioration du site web d'un point de vue de <span class="bolder">Réfférencement (SEO)</span> mais aussi <span class="bolder">l'Accessibilité (WCAG)</span>.</p>
        <div>
          <a href="https://app.box.com/s/4wizdpblw9u3deq1xj7wojpwbpisruhv" target="_blank" rel="noopener noreferrer" class="download-file">
Compte-rendu détaillé des améliorations faites
          </a>
        </div>
        <div>
          <a href="https://docs.google.com/spreadsheets/d/e/2PACX-1vR7nQ0A8WLkZodGnAhsTkKwUR1NS6lVJL97C346j8zWJ2VtYDfsZaG6hxXpCRjzyTmXia6uMWHgODu-/pubhtml?gid=981201691&single=true" class="download-file" target="_blank" rel="noopener noreferrer">
Tableur : Analyse des problèmes rencontrés
          </a>
        </div>
        <div>
          <a href="https://souleimane-z.github.io/zeggaisouleimane_4_20102021/" class="download-file" target="_blank" rel="noopener noreferrer">
Démo GitPages
          </a>
        </div>
      `,
    githubLink: "https://github.com/souleimane-z/zeggaisouleimane_4_20102021",
    techs: [
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718983533/excel-svgrepo-com_nkli94.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881734/accessibility_gfhyjr.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881732/seo_z7gahx.svg",
    ],
  },
  {
    id: "ohMyFood",
    title: "ohmyfood",
    shortDescription:
      "Site de restauration avec animations CSS/Sass, 100% responsive.",
    demoLink:
      "https://souleimane-z.github.io/ZeggaiSouleimane_3_01092021/index.html",
    tags: ["HTML", "CSS", "Sass", "Animation"],
    slides: [
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700125071/home-loading_knrsko.gif",
        title: "Home Loading",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700125071/menu-animation_ctvvqu.gif",
        title: "Menu Animation",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700125076/menu-layout_fjecwh.png",
        title: "Menu Layout",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700125067/home_irhvgd.png",
        title: "Home",
      },
    ],
    content: `
        <p>Dans ce projet, je devais créer le site à partir de maquettes, les langages utilisés étaient <span class="bolder">HTML</span> et <span class="bolder">Sass</span> pour le design. Celui-ci devait être à <span class="italic-semiBold">100% Responsive</span> et des <span class="italic-semiBold">animations</span> devaient être reproduites à partir de vidéos et d'images.</p>
        <p>Ça comprenait :</p>
        <ul class="list">
          <li>Un loader quand on arrivait sur le site</li>
          <li>Des animations au hover de la souris sur les boutons</li>
          <li>Des icônes de confirmations lors du passage de la souris.</li>
        </ul>
        <div>
          <a href="https://souleimane-z.github.io/ZeggaiSouleimane_3_01092021/index.html" class="download-file " target="_blank" rel="noopener noreferrer">
Démo GitPages
          </a>
        </div>
      `,
    githubLink: "https://github.com/souleimane-z/ZeggaiSouleimane_3_01092021",
    techs: [
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881736/html5_gvbsau.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881736/scss_ywmkkn.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881735/css3_k38wzt.svg",
    ],
  },
  {
    id: "Motiv",
    title: "cv",
    shortDescription:
      "Site de candidature créé en HTML/CSS pour postuler à OpenClassrooms.",
    demoLink: "https://souleimane-z.github.io/Motiv_2021/",
    tags: ["HTML", "CSS", "JavaScript"],
    slides: [
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700125122/about_gbncp0.png",
        title: "Home",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700125118/VwBhLd_v9930w.png",
        title: "a propos",
      },
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700125115/links_zce1qj.png",
        title: "links",
      },
    ],
    content: `
        <p>Ce site a été créé pour postuler à la formation de Développeur Web d'Openclassrooms. Entièrement codé en <span class="bolder">HTML</span> et <span class="bolder">CSS</span> pour le design.</p>
        <div>
          <a href="https://souleimane-z.github.io/Motiv_2021/" class="download-file " target="_blank" rel="noopener noreferrer">
Démo GitPages
          </a>
        </div>
      `,
    githubLink: "https://github.com/souleimane-z/Motiv_2021",
    techs: [
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881736/html5_gvbsau.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881731/javascript_sdrddu.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881735/css3_k38wzt.svg",
    ],
  },
  {
    id: "Calculator",
    title: "Calculatrice",
    shortDescription: "Calculatrice simple en JavaScript vanilla.",
    demoLink: "https://souleimane-z.github.io/simplest_calculator_SZ/",
    tags: ["JavaScript", "HTML", "CSS"],
    slides: [
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700125153/calculator_wliqqi.jpg",
        title: "Calculator demo",
      },
    ],
    content: `
        <p>Capture d'écran 'side by side' pour exemple. Simple calculatrice codée en <span class="bolder">JavaScript</span> pour le calcul, <span class="bolder">HTML</span> et <span class="bolder">CSS</span> pour le design. Essayez-la grâce au lien en dessous</p>
        <div>
          <a href="https://souleimane-z.github.io/simplest_calculator_SZ/" class="download-file" target="_blank" rel="noopener noreferrer">
Démo GitPages
          </a>
        </div>
      `,
    githubLink: "https://github.com/souleimane-z/simplest_calculator_SZ",
    techs: [
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881736/html5_gvbsau.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881731/javascript_sdrddu.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881735/css3_k38wzt.svg",
    ],
  },
  {
    id: "Clock",
    title: "Horloge",
    shortDescription:
      "Horloge analogique en JavaScript avec rotation des aiguilles.",
    demoLink: "https://souleimane-z.github.io/clock-sz/",
    tags: ["JavaScript", "HTML", "CSS"],
    slides: [
      {
        url: "https://res.cloudinary.com/dhqh98spd/image/upload/v1700125165/clock_dhphys.png",
        title: "Clock demo",
      },
    ],
    content: `
        <p>Simple horloge codée en <span class="bolder">JavaScript</span> pour l'affichage de l'heure et la rotation des aiguilles, <span class="bolder">HTML</span> et <span class="bolder">CSS</span> pour le design. Essayez-la grâce au lien en dessous</p>
        <div>
          <a href="https://souleimane-z.github.io/clock-sz/" class="download-file" target="_blank" rel="noopener noreferrer">
Démo GitPages
          </a>
        </div>
      `,
    githubLink: "https://github.com/souleimane-z/clock-sz",
    techs: [
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881736/html5_gvbsau.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881731/javascript_sdrddu.svg",
      "https://res.cloudinary.com/dhqh98spd/image/upload/v1718881735/css3_k38wzt.svg",
    ],
  },
];

export default projects;
